export default __webpack_public_path__ + "static/media/9CodeineBaby.93466e61.png";